import React from 'react';

// Material ui
import { Divider as MaterialDivider, Grid } from '@material-ui/core';

// Styles
import './Divider.scss';

interface Props {
    orientation?: 'horizontal' | 'vertical';
    className?: string;
    fullWidth?: boolean;
    tableMenu?: boolean;
}

const Divider: React.FC<Props> = ({
    orientation = 'horizontal',
    className,
    fullWidth = false,
    tableMenu = false
}) => {
    return orientation === 'horizontal' ? (
        fullWidth ? (
            <Grid
                style={{ width: '100%' }}
                className={`ui-Divider-container${className ? ` ${className}` : ''}`}
            >
                <MaterialDivider
                    className="ui-Divider-horizontal"
                />
            </Grid>
        ) : (
            <MaterialDivider
                className={`ui-Divider-horizontal${className ? ` ${className}` : ''}`}
            />
        )
    ) : (
        <MaterialDivider
            orientation="vertical"
            className={`ui-Divider-vertical${className ? ` ${className}` : ''}${tableMenu ? ' ui-Divider-vertical-table-menu' : ''}`}
        />
    );
};

export default Divider;
